import { ProductCardFragment } from '../../../ProductCardFragment'
import { ConfigurableProduct } from '../../ProductPage/ConfigurableProduct'

export type TweakwiseNavigateItem = ProductCardFragment | ConfigurableProduct

export const isConfigurable = (
    product: TweakwiseNavigateItem,
): product is ConfigurableProduct =>
    (product as ConfigurableProduct).configurableOptions !== undefined
